import { createResource } from '../core'
import { usersService } from './users.service'

/**
 * TanStack Query for users. In a component:
 *
 *   const { data, isPending, error } = useUsers({ accountId, page: 1, pageSize: 20 })
 *   const update = useUpdateUser();  update.mutate({ id, body })
 *
 * Outside React: `queryClient.fetchQuery(usersQueries.all({ accountId }))`.
 */
export const users = createResource('users', usersService)

export const usersKeys = users.keys
export const usersQueries = users.queries
export const useUsers = users.useList
export const useAllUsers = users.useAll
export const useUser = users.useOne
export const useCreateUser = users.useCreate
export const useUpdateUser = users.useUpdate
export const useDeleteUser = users.useRemove
